import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';

const MissingSubjects = ({ t, subjects }) => {
  const buildPills = () => {
    return subjects.map((subject) => (
      <span key={uuid()} className="pill">
        {subject.label}
      </span>
    ));
  };
  return (
    <div className="wrapper-card-info default">
      <span className="title">
        {t('general.missing-subjects')} ({subjects.length})
      </span>
      <div className="pills">{subjects.length ? buildPills() : null}</div>
    </div>
  );
};

MissingSubjects.propTypes = {
  t: PropTypes.func.isRequired,
  subjects: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
};

export default withTranslation('common')(MissingSubjects);
